import { GET, POST } from 'src/network/apiHandler';
import config from 'src/globals';
import { GET_VEHICLE_REQUEST_COUNT_IST, GET_VEHICLE_REQUEST_IST, SEARCH_HUBS, SEARCH_VEHICLE_MAKE } from 'src/api/routes';

const { API_BASE_URL } = config;

export const searchHubs = async (params, id) => {
  const url = API_BASE_URL + (id === 'vehicleMakeIdList' ? SEARCH_VEHICLE_MAKE : SEARCH_HUBS);
  const response = await GET(url, params);
  return response;
};

export const getVehicleRequestsISTApi = async (data) => {
  return POST(`${API_BASE_URL}${GET_VEHICLE_REQUEST_IST}`, data);
};

export const getVehicleRequestsCountISTApi = async (data) => {
  return POST(`${API_BASE_URL}${GET_VEHICLE_REQUEST_COUNT_IST}`, data);
};
